<script setup lang="ts">
import { ORDER_GET_AVAILABLE_TIME_CALCULATOR} from "~/constants/api/order/order";
import {useStoreSelectedServiceChildren} from "~/composables/store/order/serviceForm";
import {useStoreServiceInputs} from "~/composables/store/services/service_inputs";
import {useStoreDateTime} from "~/composables/store/order/datetime";
import {useStoreSelectedAddress} from "~/composables/store/user/address/store";

const { t } = useI18n()

interface OrderDataProps {
  location_id: string,
  order_type: 'b2b' | 'b2c',
  order_duration: number,
  count_master?: number,
  has_cat?: boolean,
  has_dog?: boolean,
  has_pet?: boolean
}
const props = defineProps<{
  // list: [string, string[]][],
  // orderData: OrderDataProps,
  placeholder?: string,
  errors?: Object,
  isFilled: Boolean,
  hide: Boolean,
  order: Number
}>();
const { isMobile } = useDevice()

const emit = defineEmits(['next', 'back', 'selectTime', 'error'])
const dateTime = useStoreDateTime()
const address = useStoreSelectedAddress()
const additionalServicesArray = Object.values(useStoreSelectedServiceChildren().value).map((service) => {
  return {
    id: service.service_id,
    count: service.count,
  };
}) ?? [];
const inputs = Object.values(useStoreServiceInputs().value).map((input) => ({
  input_field_id: input.input_field_id,
  value: input.default_value
}))
const orderData = ref({
  // count_master: computed(()=> useStoreCountMastersInJob().value ),
  location_id: computed(() => address.value?.city?.location_id),
  additional_services: JSON.stringify(additionalServicesArray),
  input_fields: JSON.stringify(inputs),
  // order_type: computed(() => route.path.includes('business') ? B2B : B2C),
  // order_duration: useStoreDurationJob().value * 60,
  service_id: computed(() =>useStoreSelectedService().value.service_id),

})

const list = ref(null)
const showError = ref(false)
const selectedDate = ref('')

const model = ref('')
const error = ref({
  isError: false,
  text: ''
})

model.value = {
  open: false,
  value: null
}

function validate() {
  if (!model.value.value) {
    error.value = {
      isError: true,
      text: t('order.location.datetime.select_datetime')
    }
  } else {
    error.value = {
      isError: false,
      text: ''
    }
  }
}
function goNext() {
  validate()
  if (!error.value.isError) {
    emit('next')
  }
}
function goBack() {
  emit('back', props.order)
}
async function getOrderAvailableTime() {
  let query = {...orderData.value}
  let queryString = '?'

  Object.keys(query).forEach((key, index) => {
    queryString += `${key}=${query[key] + (index === Object.keys(query).length - 1 ? '' : '&')}`
  });
  const { data: response, error, pending } = await useApi(`${ORDER_GET_AVAILABLE_TIME_CALCULATOR}${queryString}`, 'GET')

  if (response.value) {
    list.value = response.value.data
    console.log('dates', Object.keys(list.value)[0])
    selectedDate.value = Object.keys(list.value)[0]
  }
}

function selectTime(time: string, date: string) {
  error.value.isError = false
  if (!time) {
    time = '23:59'
    model.value.value = `${formatDateToSend(date)} ${time}`
    model.value.date = formatDate(model.value.value)
  } else {
    model.value.value = `${formatDateToSend(date)} ${time}`
    model.value.date = formatDate(model.value.value)
    model.value.time = time
  }
  // openCloseList()
  // emit('selectTime', model.value.value)
  dateTime.value = model.value.value
}

function formatDateToSend(date: string) {
  return date.split('.').reverse().join('-')
}

if (orderData.value.location_id) {
  getOrderAvailableTime()
}

watch(orderData.value, (val) => {
  if (val.location_id) {
    getOrderAvailableTime()
  }
})
function openCloseList() {
  if (orderData.value.location_id) {
    model.value.open = !model.value.open
    document.body.classList.toggle('overflow-hidden')
    emit('error', {
      isError: false,
      text: ''
    })
  } else {
    showError.value = true
  }
}
function getNonEmptyKeys(schedule) {
  return Object.keys(schedule).filter(key => Object.keys(schedule[key]).length > 0);
}

function handleSelectDate(date) {
  selectedDate.value = date
  if (model.value?.time) {
    selectTime(model.value?.time, date)
  }
  error.value.isError = false
}
</script>

<template>
  <div
      class="order_section flex flex-col md:gap-6 gap-4"
      :class="{ 'bg-primary-green bg-opacity-10' : isFilled }"
  >
    <div>
      <div class="flex justify-between items-center gap-6">
        <h2 class="h3">4. {{ $t('order_page.titles.cleaning_date') }}</h2>

        <UIBtn
            @click="goBack"
            v-if="isFilled && !hide"
            border="green"
        >{{ $t('input_forms.button.edit') }}</UIBtn>
      </div>

      <p v-if="model?.date && isFilled" class="mt-3 text-base font-normal text-secondary-800">
        <span>{{ model.date?.day }} {{}}</span>
        <span>{{ $t(`time.genitive.${model.date?.month}`) }}, </span>
        <span>{{ model?.time }}</span>
      </p>
    </div>

    <template v-if="!isFilled && !hide">
      <div class="bg-white p-5 rounded-[10px] flex flex-col md:flex-row justify-between gap-6">
        <div v-if="isMobile" class="flex items-center gap-2 overflow-x-scroll pb-2">
          <label
              v-for="(item, key) in list"
              :for="`select-date-${key}`"
              :class="{ 'bg-primary-green-50 border-primary-green' : selectedDate === key, 'border-secondary-400' : selectedDate != key }"
              class="border text-center rounded-md py-[2px] flex flex-col justify-between font-medium w-[44px] min-w-[44px] min-h-[52px]"
          >
            <input
                type="radio"
                name="select-date"
                :id="`select-date-${key}`"
                :value="key"
                v-model="selectedDate"
                class="hidden"
                @change="handleSelectDate(selectedDate)"
            >
            <span class="text-[10px]">{{$t(`time.${getDayOfWeek(key)}.short`)}}</span>
            <span>{{key.split('-')[2]}}</span>
            <span class="text-xs text-[#111111A6]">{{$t(`time.genitiveShort.${key.split('-')[1]}`)}}</span>
          </label>
        </div>
        <ComponentCalendar
            v-else-if="list"
            :enabledDates="getNonEmptyKeys(list)"
            :selected-dates="[selectedDate]"
            @dateSelected="handleSelectDate"
        />

        <div v-if="list && selectedDate" class="grid md:grid-cols-5 grid-cols-4 flex-auto gap-2 max-h-[296px] overflow-y-auto no-scrollbar">
          <button
              v-for="time in list[selectedDate]"
              :key="selectedDate + time + model.time"
              @click="selectTime(time, selectedDate)"
              class="min-w-[54px] min-h-[40px] flex items-center justify-center text-center text-base font-normal rounded-md border"
              :class="{'border-primary-green bg-primary-green bg-opacity-5' : model.time === time, 'border-neutral-light-gray' : model.time !== time}"
          >
            {{time}}
          </button>
        </div>
      </div>

      <p v-if="error.isError" class="text-primary-red text-sm">{{error.text}}</p>

      <UIBtn
          @click="goNext"
          color="green"
          class="w-fit ml-auto"
      >
        {{ $t('input_forms.button.save') }}
      </UIBtn>
    </template>
  </div>
</template>

<style scoped>

</style>